// extracted by mini-css-extract-plugin
module.exports = {"dap":"Microfrontends_dap__VLlQi"};